import { Tooltip } from "antd";
import styles from "./chatDeleted.module.scss";
import React from "react";
import ChatUserInfo from "../chatUserInfo";
import moment from "moment";


type DeleteMessageProps = {
  data: any;
  timeValue?:any;
};
export default function ChatDeletedMessage({ data,timeValue }: DeleteMessageProps) {
  let { direction, timestamp, fromcaller_details } = data;
  let timeCount = timeValue !== undefined ? timeValue : 18;
  let htimestamp = moment(timestamp).format("hh:mm A");
  let hhtimestamp = moment(timestamp).format("DD MMM");
  let newtamp = moment(new Date()).format("DD MMM");

  return (
    <>
      {direction === "IN" ? (
        <div className={`lftMessage ${styles.chatMsg} ${styles.leftMessage}`}>
       {timeCount > 15 &&  <div className={`${styles.chatUserDetails}`}>
          <ChatUserInfo userDetails={fromcaller_details ? fromcaller_details : 'Unknown User'} className="userinfoIcon leftSide" />
            <div className={styles.convMemName}>
              {" "}
              <span>{fromcaller_details ? fromcaller_details?.caller_id : 'Unknown User'}</span>
            </div>
          </div>}
          <div className={styles.chatLeftMessages}>
            <div className={styles.chatLeft}>
              <Tooltip mouseEnterDelay={0.5} title={htimestamp} className="cusTooltip" overlayClassName="customTooltip">
                <div className={styles.chatTime}>{htimestamp}</div>
              </Tooltip>
              <div className={`msgContentLft ${styles.chatContent}`}>
              <div className="textContent">
                <span className={`textmsg ${styles.messageDeleted}`}>
                  <span className="icon_blockdelete"></span>This message was deleted.
                </span>
                <span className="widthDeleted"></span>
              </div>
              <div className={`${styles.convTime} `} >
              <span>{newtamp === hhtimestamp ? "": hhtimestamp} {newtamp === hhtimestamp ? "": "•" } {htimestamp}</span>
              </div>
              </div>
             
                 
            </div>
          </div>
        </div>
      ) : (
        <div className={`rtMessage ${styles.chatMsg} ${styles.rightMessage}`}>
           {timeCount > 15 &&  <div className={`${styles.chatUserDetails}`}>
             <div className={styles.convMemName}>
                <span>You</span>
              </div>
             <ChatUserInfo userDetails={fromcaller_details} className="userinfoIcon rightSide" />
            </div>}
       
          <div className={styles.chatRightMessages}>
            <div className={styles.chatRight}>
              <div className={`msgContentRT ${styles.chatContent}`}>
              <div className="textContent">
                <span className={`textmsg ${styles.messageDeleted}`}>
                  <span className="icon_blockdelete"></span>You deleted this message.
                </span>
                <span className="widthDeleted"></span>
              </div>
              <div className={`${styles.convTime} `} >
              <span>{newtamp === hhtimestamp ? "": hhtimestamp} {newtamp === hhtimestamp ? "": "•" } {htimestamp}</span>
              </div>
                {/* <ChatRightInfo userDetails={fromcaller_details} timeStamp={timestamp}
                    message={data} ></ChatRightInfo> */}
              </div>
              <Tooltip
                mouseEnterDelay={0.5}
                placement="topRight"
                title={htimestamp}
                className="cusTooltip"
                overlayClassName="customTooltip"
              >
                <div className={styles.chatTime}>{htimestamp}</div>
              </Tooltip>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
